import React from "react";
import styles from "./Events.module.css";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const F1            =   <img src={require('../../Icons/Event/_F1.svg').default} height="26" draggable="false" alt="F1 Icon"/>;
const F2            =   <img src={require('../../Icons/Event/_F2.svg').default} height="26" draggable="false" alt="F2 Icon"  />;
const F3            =   <img src={require('../../Icons/Event/_F3.svg').default} height="26" draggable="false" alt="F3 Icon"/>;
const F4            =   <img src={require('../../Icons/Event/_F4.svg').default} height="26" draggable="false" alt="F4 Icon"/>;
const Keydown       =   <img src={require('../../Icons/Event/_Keydown.svg').default} height="26" draggable="false" alt="Keydown Icon"/>;
const OnClick       =   <img src={require('../../Icons/Event/_OnClick.svg').default} height="26" draggable="false" alt="onClick Icon"/>;
const OnChange      =   <img src={require('../../Icons/Event/_OnChange.svg').default} height="26" draggable="false" alt="OnChange Icon"/>;
const OnFocus       =   <img src={require('../../Icons/Event/_OnFocus.svg').default} height="26" draggable="false" alt="OnFocus Icon"/>;
const OnLostFocus   =   <img src={require('../../Icons/Event/_OnLostFocus.svg').default} height="26" draggable="false" alt="OnLostFocus Icon"/>;
const OnLoad        =   <img src={require('../../Icons/Event/_OnLoad.svg').default} height="26" draggable="false" alt="OnLoad Icon"/>;

const EventCategories = {
  'F1':F1,
  'F2':F2,
  'F3':F3,
  'F4':F4,
  'KeyDown':Keydown,
  'On Click':OnClick,
  'On Change':OnChange,
  'On Focus':OnFocus,
  'On Lost Focus':OnLostFocus,
  'On Load':OnLoad
};


const EventsSideBar = (props) => {
  const matches = useMediaQuery("(min-width:1180px)");
  const {t}=useTranslation();
  return (
    <div
      style={{
        width: !matches ? "10%":"78px",
        boxShadow: "0px 1px 3px #00000029",
        height: "inherit",
        paddingBottom: "40px",
        overflowY: "auto",
        // paddingTop: "14px",
      }}
    >
      {props.controls.map((item) => {
        // {console.log("props in event",item.label)}
        return (
          <div
            className={
              styles.eventCategory +' '+
              (props.selectedControl && props.selectedControl === item.label
                ? styles.selectedEventCategory
                : "")
            }
            onClick={() => {
              props.handleControlUpdate(item.label);
            }}
            role="region"
            aria-label="Event Sidebar"
          >
            <div
              style={{
                height: "24px",
                width: "24px",
                // border: "1px solid black",
                margin: "auto",
              }}
            >
              {EventCategories[item.label]}
            </div>
            <button className={styles.controlbtn}>{t(item.label)}</button>
          </div>
        );
      })}
    </div>
  );
};

export default EventsSideBar;
